import { create } from 'zustand';

/** Open / closed state of the Netxol AI side panel (kept apart from the panel so the top bar does not load the chat). */
export const useAiPanel = create<{ open: boolean; toggle: () => void; close: () => void }>((set) => ({ open: false, toggle: () => set((s) => ({ open: !s.open })), close: () => set({ open: false }) }));

/** Fetch the panel's code ahead of the first click (called when the browser is idle after sign-in). */
export const preloadAiPanel = () => import('./NetxolAI');
